const OrderBy = Object.freeze({
  ASC: 1,
  DESC: -1,
});

export default OrderBy;
